'use client';

import React from 'react';
import fields from './BasicDataFormConfig';
import CardForm from '../../../../components/form/CardForm';
import { useNavigate, useParams } from 'react-router-dom';
import { Actions } from '../../../../../client/Actions';

const BasicData = () => {
  const navigate = useNavigate();
  let { id } = useParams();

  return (
    <>
      <CardForm
        key={id}
        id={id}
        title={'Dane podstawowe'}
        fields={fields}
        shadow={false}
        api={'house'}
        trick="Liczba gości wpływa na możliwość rezerwacji domku. Pozostałe dane są tylko informacyjne."
        width={8}
        md={12}
        lg={8}
        customSave={(data, onSaved) => {
          const housePayload = { ...data };
          delete housePayload.lastBookingSync;
          delete housePayload.reservationCalendarExportUrl;

          if (id) {
            Actions.put('house/' + id, housePayload, onSaved);
            return;
          }

          Actions.post('house', housePayload, onSaved);
        }}
        postSaved={!id ? (saved) => navigate(`/house/${saved.id}`) : undefined}
      />
    </>
  );
};

export default BasicData;
